import getSiteIdRecreate from './get-site-id-recreate';
import getSiteIdToSwitchTemplate from './get-site-id-to-switch-template';

export default {
  getSiteIdRecreate,
  getSiteIdToSwitchTemplate,
};
